export type ConsentCategory = 'necessary' | 'analytics' | 'marketing' | 'personalization';

export interface ConsentState {
  granted: ConsentCategory[];
  grantedAt: string | null;
  version: number;
  hasResponded: boolean;
}

export interface ConsentActions {
  grantConsent: (categories: ConsentCategory[]) => void;
  revokeConsent: (categories: ConsentCategory[]) => void;
  grantAll: () => void;
  hasConsent: (category: ConsentCategory) => boolean;
  needsConsent: () => boolean;
  resetConsent: () => void;
}

export const ALL_CONSENT_CATEGORIES: ConsentCategory[] = [
  'necessary',
  'analytics',
  'marketing',
  'personalization',
];

export const EXTERNAL_ROLES = ['CANDIDATE', 'REFEREE'] as const;
export const INTERNAL_ROLES = ['SUPER_ADMIN', 'ADMIN', 'MANAGER', 'AGENT'] as const;
